// TypeScript interfaces for Manager Review Dashboard

export interface BidNote {
  id: number;
  section_name: string;
  content: string;
  created_by: string;
  created_at: string;
  updated_at: string;
  is_edited: boolean;
}

export interface ManagerDashboardBid {
  bid_id: number;
  molecule_name: string;
  status: string;
  template_name: string;
  analyst_name: string;
  reviewer_name: string;
  last_modified: string;
  progress: number;
  target_launch_date: string | null;
  notes: BidNote[];
  submitted?: string;
  approved?: string;
  launch_date?: string | null;
}

export interface ManagerDashboardResponse {
  data: ManagerDashboardBid[];
  pagination: {
    page: number;
    page_size: number;
    total_count: number;
    total_pages: number;
    has_next: boolean;
    has_previous: boolean;
  };
}

export interface ManagerDashboardFilters {
  page: number;
  page_size: number;
  search?: string;
  status?: string;
  analyst?: string;
  template_name?: string;
  reviewer?: string;
}

export interface FilterState {
  search: string;
  status: string[];
  analysts: string[];
  productTypes: string[];
  reviewers?: string[];
  createdBy?: string[];
}

export type ViewMode = 'cards' | 'list';

export type TabType = 'review-queue' | 'analytics' | 'history';

// Helper function to map template names
export const mapTemplateNameToDisplay = (templateName: string): string => {
  const lowerName = templateName.toLowerCase();
  if (lowerName === 'mas direct') return 'MAS Direct';
  if (lowerName === 'mas indirect') return 'MAS Indirect';
  if (lowerName === 'nc' || lowerName === 'national contract') return 'NC (National Contract)';
  return templateName;
};

// Helper function to map status
export const mapStatusToDisplay = (status: string): string => {
  if (status.toLowerCase() === 'in review') return 'Pending Review';
  return status;
};

